import React from "react";
import { Col, Icon } from "antd";
import styles from "./collapseTitle.scss";

const CollapseTitle = ({ onClick }) => (
  <Col
    className={styles.container}
    role="link"
    tabIndex={0}
    onClick={onClick}
    sm={24}
  >
    {"Više opcija filtriranja"}
    <Icon type="right" className={`more-search-arrow ${styles.arrow}`} />
  </Col>
);

export default CollapseTitle;



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/AllSearchControls/CollapseTitle/index.tsx